<template>
<div class="component email-field-container guest-info-container">
	<div class="include_email_opt_in">
		<div>
            <span class="field-label font-B-container">&nbsp;</span>
            <input class="input-field" type="checkbox" id="bPromoEmailOptIn" name="bPromoEmailOptIn" value="1"
            <% IF(VAR(aTemplateVars[include_email_opt_in][value])==included_default_yes) %>
                checked="checked"
            <% IF_END() %>
            />
            <label for="bPromoEmailOptIn">
                <div v-if="">
                    Sign up for our promotional emails
                </div>
                <div v-if="">
                    {{ aTemplateVars['email_opt_in_verbiage'] }}
                </div>
            </label>
        </div>
	</div>
	<div>
        <span class="field-label font-B-container">
            email
        </span>
        <input class="input-field" type="text" id="sEmail" name="sEmail" placeholder=" email" v-model="sEmail" />
    </div>
</div>
</template>

<script>

export default {
  name: "EmailFieldContainer"
}

</script>

<style scoped>

</style>